import { Component } from '@angular/core';

@Component({
  selector: 'user-subscription',
  templateUrl: './user-subscription.component.html',
  styleUrl: './user-subscription.component.scss'
})
export class UserSubscriptionComponent {}
